export default {
  public: {
    loading: "読み込み中...",
    ok: "OK",
    cancel: "キャンセル",
    back: "戻る",
    userDefined: "カスタム",
    edit: "編集",
    clear: "クリア",
    delete: "削除",
    close: "閉じる",
    remove: "削除",
    preView: "プレビュー",
    replace: "置き換え",
    systemMsg: "情報",
    generateSuccess: "パワーポイントが正常に生成されました！",
    templateChoose: "テンプレートを選択してAI作成を完了",
    templateChooseShort: "テンプレートを選択",
    templateChangeTips: "テンプレートデータを置き換えると元の内容に戻ります。変更した内容は失われます。続行してもよろしいですか？",
    sourceInvalid: "データソース無効。もう一度お試しください。",
    systemBusy: "サーバー混雑。ページを更新してください。",
    templateReplaceSuccess: "テンプレートの置き換えが成功しました。システムは自動保存しないため、手動で保存してください。",
    shareLinkTips: "コピー成功！今すぐページをリダイレクトします！",
    noPermissionTips: "申し訳ありませんが、このPPTの共有権限は作成者によって閉じられています。aippttvにログインして、想像力を発揮し、独自のPPTを作成しましょう！",
    copyTips: "コピー成功！",
    loginTips: "まずログインしてください！",
    bottomTag: "{brand}で作成",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "フォント",
      sysFont: "システムフォント",
      lineFont: "オンラインフォント",
      fontColor: "テキスト色",
      textColor: "フォント色",
      fontDelay: "フォントハイライト",
      addSize: "フォントサイズを大きく",
      duceSize: "フォントサイズを小さく",
      left: "左揃え",
      middle: "中央揃え",
      horizontalCenter: "水平中央",
      verticalCenter: "垂直中央",
      right: "右揃え",
      bottom: "下揃え",
      top: "上揃え",
      bold: "太字",
      em: "斜体",
      underline: "下線",
      strikethrough: "取り消し線",
      richText: "書式をクリア",
      textFormat: "書式のコピー/貼り付け",
      addIndex: "インデントを増やす",
      duceIndex: "インデントを減らす",
      no: "箇条書き",
      link: "ハイパーリンク",
      inputLink: "ハイパーリンクを入力",
      superscript: "上付き文字",
      subscript: "下付き文字",
      code: "インラインコード",
      blockquote: "引用",
      horizontal: "水平",
      vertical: "垂直",
      width: "幅",
      height: "高さ",
      rotate: "回転",
      uniformHorizontal: "左右に整列",
      uniformVertical: "上下に整列",
      combine: "グループ化",
      unCombine: "グループ解除",
      bgColor: "背景色",
      mainColor: "テーマカラー",
      useMainToAll: "すべてにテーマを適用",
      preMain: "定義済みテーマ",
    },
    specialEffects: {
      useAll: "すべてに適用",
      no: "なし",
      fade: "フェードイン/アウト",
      slideX: "左/右からプッシュ",
      slideY: "上/下からプッシュ",
    },
  },
  chart: {
    insertCol: "列を挿入",
    insertRow: "行を挿入",
    delCol: "列を削除",
    delRow: "行を削除",
    merCell: "セルを結合",
    unMerCell: "セルの結合を解除",
    selectCurrentCol: "現在の列を選択",
    selectCurrentRow: "現在の行を選択",
    selectAll: "すべてのセルを選択",
    toTheLeft: "左へ",
    toTheRight: "右へ",
    toTheTop: "上へ",
    toTheBottom: "下へ",
  },
  desktop: {
    fileExportSuccess: "ファイルのエクスポートが成功しました。保存場所を選択してください",
    unSupportPreviewPDF: "ここでPDFプレビューは利用できません。プレビューするにはPC公式サイトへアクセスしてください。",
  },
  extension: {
    nonsupportDownloadPDF: "ブラウザプラグインはPDFダウンロードをサポートしていません。公式サイトからダウンロードしてください",
  },
  index: {
    createText: "PPTコンテンツを生成中",
    createPage: "ページ{0}のコンテンツを生成中",
    haveProblem: "問題が発生しました",
    systemError: "{0}",
    saveText: "保存に成功しました",
    saveMessage: "保存しますか？",
    cBtn: "キャンセル",
    sBtn: "はい",
    waitMsg: "30〜40秒お待ちください。生成されない場合は、ブラウザを更新してもう一度お試しください！",
  },
  errorCode: {
    "401": "認証に失敗しました。システムリソースにアクセスできません",
    "403": "現在の操作は許可されていません",
    "404": "リソースが見つかりません",
    default: "不明なシステムエラーが発生しました。管理者に報告してください",
    notReDo: "データ処理中です。再送信しないでください。",
    loginMsg: "セッションが無効か、有効期限が切れています。もう一度ログインしてください。",
    errMsg: "システムが混雑しています。後ほど再試行してください。",
  },
  linkHandler: {
    pptPage: "スライドページ",
    change: "変更",
    remove: "削除",
  },
  editor: {
    ctrlV: "貼り付け",
    ctrlA: "すべて選択",
    enter: "新規ページ",
    f5: "スライドショー",
    delete: "ページを削除",
    ctrlD: "ページを複製",
    ctrlX: "切り取り",
    ctrlC: "コピー",
    shiftF5: "現在のページから",
    positionPanel: {
      horizontalCenter: "左右中央揃え",
      verticalCenter: "上下中央揃え",
      horizontalVerticalCenter: "上下左右中央揃え",
      left: "左揃え",
      right: "右揃え",
      top: "上揃え",
      bottom: "下揃え",
      onTop: "最前面へ移動",
      onBottom: "最背面へ移動",
      levelUp: "1つ前面へ移動",
      levelDown: "1つ背面へ移動",
      setLink: "リンクを設定",
      ungroup: "グループ解除",
      group: "グループ化",
      selectAll: "すべて選択",
      lock: "ロック",
      unlock: "ロック解除",
      delete: "削除",
    },
    canvas: {
      index: {
        ctrlR: "ルーラー",
        ctrlW: "グリッド線",
        nl: "なし",
        small: "小",
        middle: "中",
        big: "大",
        closePan: "選択パネルを閉じる",
        openPan: "選択パネルを開く",
        reCurrentPage: "現在のページをリセット",
        showPpt: "スライドショー",
        generate:'生成中...'
      },
      linkDialog: {
        url: "ウェブリンクアドレスを入力してください",
        ppt: "スライド",
        preView: "プレビュー",
        pageUrl: "ウェブリンク",
        pptPage: "スライドページ",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "元に戻す",
        reSet: "やり直す",
        text: "テキストを挿入",
        horizontal: "横書きテキストボックス",
        vertical: "縦書きテキストボックス",
        image: "画像を挿入",
        shape: "図形を挿入",
        line: "線を挿入",
        chart: "グラフを挿入",
        table: "表を挿入",
        gs: "数式を挿入",
        voice: "音声/動画を挿入",
        screen: "画面に合わせる",
        workspase: "ワークスペース",
        save: "保存",
        logo: "ロゴを挿入",
        close: "PPTを閉じる",
        share: "共有",
        download: "ダウンロード",
        templateReplacement: "テンプレート置き換え",
      },
      mediaInput: {
        videoUrl: "動画URLを入力（例：https://xxx.mp4）",
        voiceUrl: "音声URLを入力（例：https://xxx.mp3）",
        video: "動画",
        voice: "音声",
        videoError: "まず正しい動画URLを入力してください",
        voiceError: "まず正しい音声URLを入力してください",
      },
      tableGenerator: {
        table: "表",
        row: "行",
        column: "列",
        rcError: "行/列は0〜20の間で指定してください！",
      },
      logo: {
        text1: "会社ロゴをアップロード",
        text2: "会社名を入力",
        companyNamePlaceholder: "会社名を入力",
        single: "単一ページに適用",
        all: "全ページに適用",
        position: "位置",
      },
    },
    editorHeader: {
      index: {
        file: "ファイル",
        importPptistFile: "pptistファイルをインポート",
        importPptxFile: "pptxファイルをインポート",
        exportPptxFile: "ファイルをエクスポート",
        undo: "元に戻す",
        redo: "やり直す",
        createSlide: "ページを追加",
        deleteSlide: "ページを削除",
        closeGridLines: "グリッド線を閉じる",
        openGridLines: "グリッド線を開く",
        closeRuler: "ルーラーを閉じる",
        openRuler: "ルーラーを開く",
        resetSlides: "スライドをリセット",
        closeSelectPanel: "選択パネルを閉じる",
        openSelectPanel: "選択パネルを開く",
        f5: "プレゼンテーション",
        enterScreeningFromStart: "最初から開始",
        enterScreening: "現在のページから開始",
        help: "ヘルプ",
        hotkey: "ホットキー",
        pptShow: "スライドショー",
        export: "エクスポート",
        importing: "インポート中...",
        continue: "続行",
        pauseGeneration: "一時停止",
        noPricing: "メンバーになってダウンロード特典を楽しみましょう。",
        noPricingToOpt: "すべての特典を取得",
        getTokens: "プロにアップグレード",
        pptSlidesMsg: "おめでとうございます！{0}ページのPPT作成が完了しました！ ",
        Feedback: "AIを仕事のアシスタントに。",
        giveAway: "クーポンプレゼント（30分間有効）",
        getItNow: "今すぐ入手",
        unlockAllPpt: "すべてのPPT機能を解放",
        grantPermission: "AIマインドマップ使用権限を付与",
        grantPermissionToUseGpt: "GPT使用権限を付与",
        permissionCodeUse: "割引コードを覚えて、支払いページで使用してください！",
        pptTi1: "すべての作業を完了し、合計{0}ページのpptを生成しました。 ",
        pptTi2: "素晴らしいAI作成物を手に入れるには、最後のステップだけです！",
      },
    },
    exportDialog: {
      tips:'アプリでは現在PPTダウンロードをサポートしていません。PCでダウンロードしてください。',
      exportScope: "エクスポート範囲",
      close: "閉じる",
      all: "すべて",
      thisPage: "現在のページ",
      auto: "カスタム",
      autoScope: "カスタム範囲",
      exporting: "エクスポート中...",
      exportImg: "画像をエクスポート",
      expPdf: "PDFを印刷/エクスポート",
      expPptx: "PPTXをエクスポート",
      downloadSuccess: "ファイル変換が成功しました。保存先を選択してください",
      exportImage: {
        exportType: "エクスポート形式",
        imageQuality: "画質",
        ignoreFont: "オンラインフォントを無視",
        ignoreLineFont: "デフォルトでは、エクスポート時にオンラインフォントは無視されます。プレゼンテーションでオンラインフォントを使用しており、エクスポート後もそのスタイルを保持したい場合は、「オンラインフォントを無視」オプションをオフにできます。でも、エクスポート時間が長くなる可能性があることに注意してください。",
      },
      exportPdf: {
        all: "すべてのスライド",
        thisPage: "現在のスライド",
        pageNum: "1枚あたりのページ数",
        white: "余白",
        notice: "ご注意：印刷プレビューが実際のスタイルと一致しない場合は、ポップアップ印刷ウィンドウの「背景グラフィック」オプションを確認してください。",
      },
      exportPPTX: {
        title: "デフォルトマスターを上書き",
        notice: "ご注意：ダウンロード後はMicrosoft Officeで開いてください。他のソフトでは互換性がない場合があります。",
      },
    },
    remark: {
      remark: "スピーカーノートを入力",
    },
    thumbnails: {
      add: "スライドを追加",
      slide: "スライド",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "色を変更（マスク）",
          maskColor: "マスク色",
          opacity: "不透明度",
        },
        elementFilter: {
          enableFilter: "フィルターを有効化",
          blur: "ぼかし",
          brightness: "明るさ",
          contrast: "コントラスト",
          grayscale: "グレースケール",
          saturate: "彩度",
          hueRotate: "色相回転",
          opacity: "不透明度",
        },
        elementFlip: {
          horizontal: "水平反転",
          vertical: "垂直反転",
        },
        elementOpacity: {
          opacity: "不透明度",
        },
        elementOutline: {
          border: "枠線を有効化",
          borderStyle: "枠線スタイル",
          solid: "実線",
          dashes: "破線",
          borderColor: "枠線色",
          borderWeight: "枠線の太さ",
        },
        elementShadow: {
          enable: "影を有効化",
          horizontal: "水平方向の影",
          vertical: "垂直方向の影",
          fuzzyDistance: "ぼかし距離",
          color: "影の色",
        },
      },
      panel: {
        background: "背景塗りつぶし",
        solid: "単色塗りつぶし",
        image: "画像塗りつぶし",
        gradient: "グラデーション塗りつぶし",
        contain: "フィット",
        repeat: "タイル",
        cover: "塗りつぶし",
        linear: "線形グラデーション",
        radial: "円形グラデーション",
        startColor: "開始色",
        endColor: "終了色",
        rotate: "グラデーション角度",
        useBackgroundToAll: "背景をすべてに適用",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "カテゴリ",
            colType: "シリーズ",
          },
          index: {
            edit: "グラフデータを編集",
            area: "面タイル",
            line: "散布図スタイル",
            lineSmooth: "スムーズラインを使用",
            horizontalBars: "横棒スタイル",
            stackBars: "縦棒スタイル",
            donut: "ドーナツグラフスタイル",
            img: "凡例",
            hidden: "非表示",
            showTop: "上部に表示",
            showBottom: "下部に表示",
            tabColor: "グリッド色",
            labelColor: "フォント色",
            titleSetColor: "テーマカラー:",
            title: "推奨テーマ",
            titleColor: "テーマカラーを追加",
          },
        },
        audioStylePanel: {
          imgColor: "アイコン色",
          autoPlay: "自動再生",
          loopPlay: "ループ再生",
        },
        imageStylePanel: {
          cutImg: "画像をトリミング",
          shape: "形状で",
          type: "カテゴリ",
          preview: "プレビュー",
          use: "使用",
          searchByType: "カテゴリで検索",
          uploadAndReplace: "画像をアップロードして置き換え",
          reSetStyle: "スタイルをリセット",
          setBackground: "背景に設定",
          clip1: "縦横比で（正方形）",
          clip2: "縦横比で（縦長）",
          clip3: "縦横比で（横長）",
        },
        latexStylePanel: {
          edit: "LaTeXを編集",
          color: "色",
          bold: "太字",
        },
        lineStylePanel: {
          style: "線スタイル",
          solid: "実線",
          dotted: "点線",
          color: "線の色",
          weight: "線の太さ",
          startStyle: "始点スタイル",
          endStyle: "終点スタイル",
          none: "なし",
          arrow: "矢印",
          dot: "丸",
        },
        multiStylePanel: {
          colorPicker: "塗りつぶし色",
          style: "枠線スタイル",
          solid: "実線",
          dotted: "点線",
          color: "枠線色",
          weight: "枠線の太さ",
        },
        shapeStylePanel: {
          replaceShade: "クリックして形状を置き換え",
          fill: "単色塗りつぶし",
          gradient: "グラデーション塗りつぶし",
          linear: "線形グラデーション",
          radial: "円形グラデーション",
        },
        tableStylePanel: {
          colFull: "セルの塗りつぶし",
          row: "行",
          col: "列",
          titleRow: "タイトル行",
          totalRow: "合計行",
          firstCol: "最初の列",
          lastCol: "最後の列",
          titleColor: "テーマカラー",
          themeTable: "テーマテーブル",
        },
        textStylePanel: {
          urlError: "正しいウェブリンクアドレスではありません",
          command: "箇条書き",
          lineHeight: "行間",
          times: "倍数",
          paragraphSpace: "段落間隔",
          wordSpace: "単語間隔",
          textIndent: "最初の行のインデント",
          textFill: "テキストボックスの塗りつぶし",
          title: "タイトル",
          titleSmall: "サブタイトル",
          text: "テキスト",
          textSmall: "テキスト[小]",
          zs1: "注記1",
          zs2: "注記2",
        },
        videoStylePanel: {
          cover: "動画サムネイル",
          recover: "サムネイルをリセット",
        },
      },
      elementAnimationPanel: {
        addEffects: "アニメーションを追加",
        selectAndAddEffects: "カンバス上の要素を選択してアニメーションを追加",
        time: "継続時間",
        triggerType: "タイミング",
        initiative: "クリック時",
        sameTime: "直前の動作と同時",
        after: "直前の動作の後",
        change: "アニメーションを変更",
        in: "開始",
        out: "終了",
        attention: "強調",
      },
      elementPositionPanel: {
        layer: "レイヤー",
        align: "整列",
        top: "最前面へ",
        bottom: "最背面へ",
        up: "前面へ移動",
        down: "背面へ移動",
        noRixedRatio: "縦横比のロックを解除",
        fixedRatio: "縦横比をロック",
      },
      index: {
        style: "スタイル",
        symbol: "記号",
        position: "位置",
        animation: "アニメーション",
        design: "デザイン",
        slideAnimation: "切り替え効果",
      },
      slideDesignPanel: {
        canvasSize: "カンバスサイズ",
        wideScreen1: "ワイドスクリーン 16:9",
        wideScreen2: "ワイドスクリーン 16:10",
        standard: "標準 4:3",
        paper: "A3 / A4 用紙",
        title: "グローバルテーマ",
        mainColor: "テーマカラー",
        useMainToAll: "テーマをすべてに適用",
        preMain: "定義済みテーマ",
        text: "テキスト Aa",
        use: "適用",
        useToAll: "すべてに適用",
      },
    },
    selectPanel: {
      select: "選択",
      showAll: "すべて表示",
      hideAll: "すべて非表示",
      group: "グループ化",
    },
    redraw: {
      topLabel: "再生成",
      msgTips: "生成したコンテンツを入力してください",
      retext: "再生成",
      cltext: "キャンセル",
      btnText: "作成",
      reConfirm: "生成すると現在のページが置き換えられ、履歴コンテンツは保存されません。続行してもよろしいですか？",
      confirmBtnTxt: "続行",
    },
  },
  screen: {
    presenter: {
      normalView: "通常ビュー",
      pen: "ペン",
      laserPointer: "レーザーポインター",
      timer: "タイマー",
      exitFullScreen: "全画面表示を終了",
      fullScreen: "全画面表示",
      endPresentation: "プレゼンテーションを終了",
      speakerNotes: "スピーカーノート",
      speakersView: "スピーカービュー",
      previousPage: "前のページ",
      nextPage: "次のページ",
      firstPage: "最初のページ",
      lastPage: "最後のページ",
      brushTool: "ブラシツール",
      noRemarks: "ノートなし",
      lastPageTips: "すでに最後のページです",
      firstPageTips: "すでに最初のページです",
      autoPlay: "自動スライドショーを開始",
    },
    writingBoard: {
      inkThickness: "インクの太さ",
      eraserSize: "消しゴムのサイズ",
      eraser: "消しゴム",
      clearInk: "インクをクリア",
      blackboard: "黒板",
      closeBrush: "ブラシを閉じる",
    },
  },
  mobile: {
    index: {
      notSupport: "モバイル版は急ぎ開発中です。",
      toPc: "PCでウェブサイトにアクセスしてください。",
      editTips: "PCで編集してください。",
    },
  },
  useCreateElement: {
    type: "タイプ{0}",
    class: "シリーズ{0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "LaTeX数式を入力",
        preViw: "数式プレビュー",
        symbol: "よく使われる記号",
        formula: "定義済み数式",
        error: "数式は空にできません",
      },
    },
    colorPicker: {
      recentUse: "最近使用",
    },
  },
  config: {
    latex: {
      gauss: "ガウスの公式",
      fourierSeries: "フーリエ級数",
      taylorExpansion: "テイラー展開",
      definiteIntegral: "定積分",
      trigonometricIdentity1: "三角恒等式1",
      trigonometricIdentity2: "三角恒等式2",
      expansion: "和の展開",
      euler: "オイラーの公式",
      differential: "ベルヌーイ方程式",
      totalDifferentialEquation: "全微分方程式",
      homogeneous: "非同次方程式",
      cauchy: "コーシーの平均値の定理",
      lagrange: "ラグランジュの平均値の定理",
      arcsin: "導関数の公式",
      trigonometric: "三角関数の積分",
      quadric: "二次曲面",
      dx: "二階微分",
      partial: "方向微分",
      operators: "数学演算子",
      group: "組み合わせ",
      verbatim: "関数",
      greek: "ギリシャ文字",
    },
    symbol: {
      letter: "文字",
      number: "数字",
      math: "数学記号",
      arrow: "矢印",
      graph: "図形",
    },
    lines: {
      straight: "直線",
      brokenOrCurve: "折れ線/曲線",
    },
  },
  hotkey: {
    opt: {
      common: "共通",
      ctrlX: "切り取り",
      ctrlC: "コピー",
      ctrlV: "貼り付け",
      ctrlD: "クイックコピペ",
      ctrlA: "すべて選択",
      ctrlZ: "元に戻す",
      ctrlY: "やり直す",
      del: "削除",
      ctrlMore: "複数選択",
      ctrlP: "印刷",
      esc: "ポップアップを閉じる",
    },
    slide: {
      show: "スライドショー",
      edit: "スライド編集",
      first: "最初からスライドショーを開始",
      current: "現在からスライドショーを開始",
      spacePre: "前のページに切り替え",
      spaceNext1: "次のページに切り替え",
      spaceNext2: "次のページに切り替え",
      out: "プレゼンテーションを終了",
      new: "新規スライド",
      move: "カンバスを移動",
      upOrDown: "カンバスをズーム",
      up: "カンバスを拡大",
      down: "カンバスを縮小",
      screen: "カンバスを現在の画面に合わせる",
      noSelectPrePage: "前のページ（要素未選択時）",
      noSelectNextPage: "次のページ（要素未選択時）",
      prePage: "前のページ",
      nextPage: "次のページ",
    },
    element: {
      opt: "要素操作",
      move: "移動",
      lock: "ロック",
      combo: "グループ化",
      cancelCombo: "グループ解除",
      top: "最前面へ",
      bottom: "最背面へ",
      h: "縦横比をロック",
      v: "水平/垂直線を作成",
      change: "フォーカス要素を切り替え",
      com: "画像トリミングを確定",
      text: "テキスト",
      image: "画像",
      shape: "形状",
      line: "線",
      chart: "グラフ",
      table: "表",
      video: "動画",
      audio: "音声",
      latex: "数式",
    },
    table: {
      edit: "表編集",
      nextCol: "次のセルにフォーカス",
      insertTop: "上に行を挿入",
      insertBottom: "下に行を挿入",
      insertLeft: "左に列を挿入",
      insertRight: "右に列を挿入",
    },
    chat: {
      edit: "グラフデータ編集",
      nextLine: "次の行にフォーカス",
    },
    text: {
      edit: "テキスト編集",
      bold: "太字",
      italics: "斜体",
      underline: "下線",
      delLine: "取り消し線",
    },
  },
  shape: {
    rectangle: "長方形",
    commonUse: "よく使われる形状",
    arrow: "矢印",
    other: "その他の形状",
    line: "線",
  },
  animation: {
    in: {
      bounce: "バウンス",
      bounceIn: "バウンスイン",
      bounceInLeft: "左からバウンスイン",
      bounceInRight: "右からバウンスイン",
      bounceInUp: "上からバウンスイン",
      bounceInDown: "下からバウンスイン",
      fade: "フェード",
      fadeIn: "フェードイン",
      fadeInDown: "下からフェードイン",
      fadeInDownBig: "下から大きくフェードイン",
      fadeInLeft: "左からフェードイン",
      fadeInLeftBig: "左から大きくフェードイン",
      fadeInRight: "右からフェードイン",
      fadeInRightBig: "右から大きくフェードイン",
      fadeInUp: "上からフェードイン",
      fadeInUpBig: "上から大きくフェードイン",
      fadeInTopLeft: "左上からフェードイン",
      fadeInTopRight: "右上からフェードイン",
      fadeInBottomLeft: "左下からフェードイン",
      fadeInBottomRight: "右下からフェードイン",
      rotate: "回転",
      rotateIn: "回転イン",
      rotateInDownLeft: "左下から回転イン",
      rotateInDownRight: "右下から回転イン",
      rotateInUpLeft: "左上から回転イン",
      rotateInUpRight: "右上から回転イン",
      zoom: "ズーム",
      zoomIn: "ズームイン",
      zoomInDown: "下からズームイン",
      zoomInLeft: "左からズームイン",
      zoomInRight: "右からズームイン",
      zoomInUp: "上からズームイン",
      slide: "スライド",
      slideInDown: "上からスライドイン",
      slideInLeft: "左からスライドイン",
      slideInRight: "右からスライドイン",
      slideInUp: "下からスライドイン",
      flip: "フリップ",
      flipInX: "X軸方向フリップイン",
      flipInY: "Y軸方向フリップイン",
      back: "バック",
      backInDown: "上からバックイン",
      backInLeft: "左からバックイン",
      backInRight: "右からバックイン",
      backInUp: "下からバックイン",
      lightSpeed: "スピード",
      lightSpeedInRight: "右からスピードイン",
      lightSpeedInLeft: "左からスピードイン",
    },
    out: {
      bounce: "バウンス",
      bounceOut: "バウンスアウト",
      bounceOutLeft: "左へバウンスアウト",
      bounceOutRight: "右へバウンスアウト",
      bounceOutUp: "上へバウンスアウト",
      bounceOutDown: "下へバウンスアウト",
      fade: "フェード",
      fadeOut: "フェードアウト",
      fadeOutDown: "下へフェードアウト",
      fadeOutDownBig: "大きく下へフェードアウト",
      fadeOutLeft: "左へフェードアウト",
      fadeOutLeftBig: "大きく左へフェードアウト",
      fadeOutRight: "右へフェードアウト",
      fadeOutRightBig: "大きく右へフェードアウト",
      fadeOutUp: "上へフェードアウト",
      fadeOutUpBig: "大きく上へフェードアウト",
      fadeOutTopLeft: "左上へフェードアウト",
      fadeOutTopRight: "右上へフェードアウト",
      fadeOutBottomLeft: "左下へフェードアウト",
      fadeOutBottomRight: "右下へフェードアウト",
      rotate: "回転",
      rotateOut: "回転アウト",
      rotateOutDownLeft: "左下へ回転アウト",
      rotateOutDownRight: "右下へ回転アウト",
      rotateOutUpLeft: "左上へ回転アウト",
      rotateOutUpRight: "右上へ回転アウト",
      zoom: "ズーム",
      zoomOut: "ズームアウト",
      zoomOutDown: "下へズームアウト",
      zoomOutLeft: "左へズームアウト",
      zoomOutRight: "右へズームアウト",
      zoomOutUp: "上へズームアウト",
      slide: "スライド",
      slideOutDown: "下へスライドアウト",
      slideOutLeft: "左へスライドアウト",
      slideOutRight: "右へスライドアウト",
      slideOutUp: "上へスライドアウト",
      flip: "フリップ",
      flipOutX: "X軸方向フリップアウト",
      flipOutY: "Y軸方向フリップアウト",
      back: "バック",
      backOutDown: "下へバックアウト",
      backOutLeft: "左へバックアウト",
      backOutRight: "右へバックアウト",
      backOutUp: "上へバックアウト",
      lightSpeed: "スピード",
      lightSpeedOutRight: "右へスピードアウト",
      lightSpeedOutLeft: "左へスピードアウト",
    },
    attention: {
      shake: "揺れる",
      shakeX: "X方向に揺れる",
      shakeY: "Y方向に揺れる",
      headShake: "首振り",
      swing: "揺らす",
      wobble: "ぐらつく",
      tada: "タダ",
      jello: "ゼリー",
      other: "その他",
      bounce: "バウンス",
      flash: "フラッシュ",
      pulse: "脈動",
      rubberBand: "ゴムバンド",
      heartBeat: "心拍",
    },
  },
  requestError: {
    tokenExpires: "認証に失敗しました。システムリソースにアクセスできません",
    permissionDenied: "現在の操作は許可されていません",
    notFound: "リソースが見つかりません",
    default: "不明なシステムエラーが発生しました。管理者に報告してください",
    exceptionReminder: "例外の通知",
    pleaseLogin: "セッションが無効か、有効期限が切れています。もう一度ログインしてください。",
    networkError: "ネットワークエラー",
    requestTimeOut: "システムインターフェースのリクエストがタイムアウトしました",
    requestFailed: "リクエストが失敗しました",
  },
  promptsText: {
    theme: [
      "多彩なテーマを探検して、無限の楽しみを発見しよう！",
      "各テーマページをクリック！魔法の旅が始まります",
      "それぞれのテーマに独自の魅力あり、全部探索してみませんか？",
      "テーマの世界へようこそ。興味のあるものを選んで冒険をスタート！",
      "あなたのためのAIスライドショー、まもなく到着！",
      "スライドショーの旅が今まさに出発...",
      "新たなビジュアル体験の準備は？スライドショー開始まであと少し...",
      "シートベルトを締めて！次は素晴らしいスライドショーの世界へ...",
      "さあ目を閉じて！驚きのスライドショーがやってくる...",
      "スライドショーの世界が今、あなたの目の前に広がります...",
      "少々お待ちください。夢のようなスライドショーを準備中..."
    ],
    directory: [
      "ディレクトリページですべてが見つかる！",
      "ナビゲーションの宝庫！欲しい情報がすぐ見つかるディレクトリページ",
      "包括的なナビゲーションで目的を素早く達成！",
      "迷ったらここ！ディレクトリページでインスピレーションを得よう"
    ],
    Content: [
      "お待たせ中...次のスライドは虹のように鮮やかに！",
      "わあ！次のスライドが花火のように咲き誇ります！",
      "お楽しみはこれから...夢のようなスライドがすぐに！",
      "待つ時間もワクワクの一部！次は目が輝くスライドが...",
      "乞うご期待！次のスライドが驚きのビジュアルを届けます",
      "さあカーテンオープン！次のスライドの輝きを感じて",
      "準備はいい？次は新鮮なビジュアルの嵐がやってくる！",
      "あなたの好奇心、すぐに満たされます！",
      "まもなく...素晴らしいビジュアルの旅へご案内！",
      "待ちきれない？次のスライドは祭りのように熱狂的！",
      "次はどんなスライド？答えはすぐに...",
      "安全ベルト着用！次のスライドへ飛び立ちます",
      "幸せが加速接近！次のスライドがあなたのもとへ...",
      "次は何色の世界？その答えは...",
      "わあ！予想を超えるサプライズが...",
      "試したくてウズウズ？好奇心を満たすスライドが...",
      "ワクワク待機中...次のスライドが喜びを運んでくる",
      "待つ時間も至福...美味しいコーヒーを待つように",
      "目を閉じて3つ数えて...1...2...3... サプライズ登場！",
      "冒険は続く！次のスライドは宝探しのようにワクワク",
      "準備OK？次は素晴らしい冒険の始まり！"
    ],
    Comprehensive: [
      "一歩ずつ、無限の楽しみの世界を探検しよう",
      "テーマ→ディレクトリ→コンテンツへ。発見の連続！",
      "一緒に素晴らしい旅へ。この世界に私たちの足跡を残そう",
      "驚きに満ちたこの世界で、もっとたくさんの発見を"
    ],
    Unpurchased: [
      "試してみたい？次のスライドでビジュアル体験をスタート！",
      "製品というより、新しいライフスタイル！クリックで気分を解放",
      "ここで買うのは製品だけでなく、豊かな幸せそのもの",
      "メンバー登録で、喜びに満ちた新生活をスタート",
      "購入クリックで、毎日を驚きと楽しみで満たそう",
      "購入は行動以上のもの。人生を楽しむための選択",
      "チャンスを掴んで、生活をよりカラフルに！",
      "購入は素晴らしい冒険。さあ、この旅へ出かけよう",
      "クリック一つで、自分へのご褒美を",
      "購入は自己表現。心を込めて選びましょう"
    ]
  },
};